export const GET_STOCK_LISTS = "GET_STOCK_LISTS";
export const GET_STOCK_LIST = "GET_STOCK_LIST";
export const ADD_STOCK_LIST = "ADD_STOCK_LIST";
export const DELETE_STOCK_LIST = "DELETE_STOCK_LIST";
export const UPDATE_STOCK_LIST = "UPDATE_STOCK_LIST";
